import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { CRouteList, ErrorPaths } from '@app/route-list.const';
import { LoggerService } from '@core/logger/logger.service';
import { NavigationService } from '@core/navigation/navigation.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: true,
  imports: [TranslatePipe, MatIconModule]
})
export class ErrorPageComponent {
  title: string;
  description: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private logger: LoggerService,
    private navigationService: NavigationService
  ) {
    this.title = this.getTitle(this.router.url);
    this.description = this.getDescription(this.router.url);

    this.logUnexpectedErrorUrl();
  }

  private async logUnexpectedErrorUrl() {
    const data = await firstValueFrom(this.route.data);
    const urlWithoutBase = this.navigationService.getUrlWithoutBase(data.url).replace(/^\/+/, '');

    if (urlWithoutBase && !ErrorPaths.includes(urlWithoutBase)) {
      this.logger.info(`Unhandled route redirected to error. Original URL: ${urlWithoutBase}`);
      this.logger.flushLog();
    }
  }

  getDescription(url: string): string {
    if (url.includes(CRouteList.lost)) {
      return 'ERROR_PAGE.JEDI_MIND_TRICK';
    }

    if (url.includes(CRouteList.maintenance)) {
      return 'ERROR_PAGE.COME_BACK_LATER';
    }

    if (url.includes(CRouteList.errorStorage)) {
      return 'ERROR_PAGE.STORAGE_NOT_AVAILABLE';
    }

    return 'ERROR_PAGE.SORRY';
  }

  getTitle(url: string): string {
    if (url.includes(CRouteList.lost)) {
      return 'ERROR_PAGE.PAGE_NOT_FOUND';
    }

    if (url.includes(CRouteList.maintenance)) {
      return 'ERROR_PAGE.MAINTENANCE_MODE';
    }

    // error and error storage
    return 'ERROR_PAGE.ERROR';
  }
}
